<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th class="primary--text">
          {{ $i18n.t("Comment For") }}
        </th>
        <th class="primary--text">{{ $i18n.t("Comment") }}</th>
        <th class="primary--text">
          {{ $i18n.t("Comment By") }}
        </th>
        <th class="primary--text">
          {{ $i18n.t("Comment At") }}
        </th>
      </tr>
    </thead>

    <tbody v-if="comments">
      <tr v-for="(com, index) in comments" :key="index">
        <td>{{ commentFor(com.commentsFor) }}</td>
        <td><div v-html="com.msg" class="text-size"/></td>
        <td>{{ com.by }}</td>
        <td>{{ com.at | moment("HH:mm DD MMM YYYY")}}</td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { Vue, Component } from "vue-property-decorator";

@Component({
  name: "AllComments",
  props: {
    value: {
      default: false,
    },
    comments: {
      default: null,
    },
  },
})
export default class AllComments extends (Vue, Themeable) {
  commentFor(comFor) {
    if (comFor == 1) {
      return "Driver";
    } else if (comFor == 2) {
      return "Admin";
    } else if (comFor == 3) {
      return "Passenger";
    } else {
      return "All";
    }
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
.actionBox {
  position: sticky;
  background: white;
  bottom: 0px;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-top: 1px solid #dfdfdf;
  padding: 10px;
}
</style>
